import { render } from "./ChartCitieStatistics.vue?vue&type=template&id=fe05b05a&ts=true"
import script from "./ChartCitieStatistics.vue?vue&type=script&lang=ts"
export * from "./ChartCitieStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__